import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaMapMarkerAlt, FaPhone, FaFacebookF, FaTwitter,
  FaInstagram, FaYoutube, FaTelegram
} from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import ThankYouModal from './ThankYouModal';

const FooterNew = () => {
  const rainContainerRef = useRef(null);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);

  useEffect(() => {
    // Rain effect - let's make it VERY visible
    if (!rainContainerRef.current) return;

    const container = rainContainerRef.current;

    // Create static raindrops first to ensure they show
    for (let i = 0; i < 200; i++) {
      const raindrop = document.createElement('div');
      raindrop.className = 'raindrop';
      raindrop.style.left = `${Math.random() * 100}%`;
      raindrop.style.top = `${Math.random() * 100}%`;
      raindrop.style.animationDuration = `${Math.random() * 2 + 1}s`;
      raindrop.style.animationDelay = `${Math.random() * 2}s`;
      container.appendChild(raindrop);
    }

    return () => {
      // Cleanup
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowThankYou(true);

    // Fire Meta Pixel Lead event
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_name: 'footer_contact', content_category: 'form_submission' });
    }

    setEmail('');
    setName('');
    setMessage('');
  };

  const galleryImages = [
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients1.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients5.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients7.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients8.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients9.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients10.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients11.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients1.webp',
    '/assets/assets/images/new/customer-vehicles/paradise-performance-clients5.webp'
  ];

  return (
    <>
      {/* Thank You Modal with Google Ads Conversion Tracking */}
      <ThankYouModal
        isOpen={showThankYou}
        onClose={() => setShowThankYou(false)}
        title="Message Sent!"
        message="Thank you for your message! We will get back to you soon."
        autoClose={true}
        autoCloseDelay={5000}
      />

      <style>{`
        .footer-wrapper {
          position: relative;
          width: 100%;
          background-color: #cd0f0fff;
          overflow: hidden;
          margin-top: auto;
        }

        .footer-top {
          background-color: oklch(17.6% .021 244);
          padding: 60px 10% 0;
          color: #b0b0b0;
        }

        .footer-bottom {
          padding: 0 0 13.75px 0;
          border-top: 1px solid #192c6aff;
          background-color: #0f1924ff;
        }

        .footer-logo {
          border-radius: 10px;
          box-shadow: 3px 9px 16px rgba(0, 0, 0, 0.4),
            -3px -3px 10px rgba(255, 255, 255, 0.06);
          transition: all 0.3s ease;
        }

        .footer-logo:hover {
          box-shadow: 0 0px 20px rgba(1, 30, 84, 0.7);
          transform: scale(1.05);
        }

        .footer-description {
          color: #99a9b5;
          text-align: center;
          font-size: 13.75px;
          line-height: 22px;
          margin: 3vh 8vw 6vh;
          padding: 0 13.75px;
        }

        .footer-title {
          color: #fff;
          font-weight: 500;
          font-size: 16px;
          margin-bottom: 20px;
          position: relative;
          padding-bottom: 10px;
        }

        .footer-title:after {
          width: 50px;
          background: #000000ff;
          opacity: 0.2;
          height: 1px;
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .footer-link {
          color: #99a9b5 !important;
          text-decoration: none !important;
          font-size: 14px;
          transition: all 0.3s ease;
          display: block;
          margin-bottom: 8px;
        }

        .footer-link:hover {
          color: white !important;
          padding-left: 5px;
        }

        .footer-input {
          background: #0f1824ff;
          border: 1px solid #05132dff;
          border-radius: 5px;
          padding: 12px;
          width: 100%;
          color: #38444dff;
          font-size: 14px;
          margin-bottom: 13.75px;
          box-shadow: .10px .10px 3.36px rgba(10, 10, 30, 0.5),
            -.13px -.13px 2.3px rgba(55, 125, 255, 0.3);
          transition: all 0.3s ease;
        }

        .footer-input:focus {
          outline: none;
          background-color: transparent;
          box-shadow: 10px 10px 36px rgba(0, 0, 0, 0.5),
            -13px -13px 23px rgba(255, 255, 255, 0.03),
            inset 14px 14px 70px rgba(0, 0, 0, 0.2),
            inset -13.75px -13.75px 30px rgba(255, 255, 255, 0.04);
          border-color: rgba(255, 255, 255, 0.2);
          color: white;
        }

        .footer-submit {
          background-color: #163169ff;
          color: rgba(255, 255, 255, 0.5);
          border: 1px double #163169ff;
          border-radius: 5px;
          padding: 12px 30px;
          font-size: 14px;
          font-weight: 400;
          text-transform: uppercase;
          letter-spacing: 1px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 3px 9px 16px rgba(0, 0, 0, 0.4),
            -3px -3px 10px rgba(255, 255, 255, 0.06),
            inset 14px 14px 26px rgba(0, 0, 0, 0.3),
            inset -3px -3px 13.75px rgba(255, 255, 255, 0.05);
        }

        .footer-submit:hover {
          box-shadow: 0 0px 2px rgba(84, 1, 1, 0.7);
          border-color: rgba(255, 6, 6, 0.28);
          background: linear-gradient(
            to right,
            rgba(255, 9, 9, 0.13),
rgba(255, 0, 0, 0.71),
            rgba(255, 0, 0, 0.14)
          );
          color: white;
        }

        .social-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          margin: 0 5px;
          border-radius: 50%;
          background-color: #141421;
          border: 1px solid #2e2e4c;
          box-shadow: 3px 9px 16px rgba(0, 0, 0, 0.4),
            -3px -3px 10px rgba(255, 255, 255, 0.06),
            inset 14px 14px 26px rgba(0, 0, 0, 0.3),
            inset -3px -3px 13.75px rgba(255, 255, 255, 0.05);
          transition: all 0.3s ease;
          text-decoration: none !important;
        }

        .social-icon:hover {
          box-shadow: 0 0px 20px rgba(8, 189, 254, 0.7);
          border-color: rgba(6, 189, 255, 0.61);
          background: linear-gradient(
            to right,
            rgba(12, 189, 249, 0.129),
          rgba(8, 189, 254, 0.71),
            rgba(0, 132, 255, 0.14)
          );
        }

        .rain-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          overflow: hidden;
          z-index: 3;
        }

        .raindrop {
          position: absolute;
          top: -10px;
          width: .058px;
          height:69px;
          background: linear-gradient(
            to bottom,
            oklch(59% .08 240 /.295),
            oklch(40% .18 240 /.32) 50%,
            oklch(39% .08 240 /.45) 800%
          );
          animation: rain-fall linear infinite;
        }

        @keyframes rain-fall {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(calc(80vh + 200px));
          }
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 3px;
        }

        .gallery-img {
          width: 100%;
          height: 60px;
          object-fit: cover;
          border-radius: 5px;
          box-shadow: 3px 9px 16px rgba(0, 0, 0, 0.4),
            -3px -3px 10px rgba(255, 255, 255, 0.06);
          transition: all 0.3s ease;
        }

        .gallery-img:hover {
          box-shadow: 0 0px 20px rgba(54, 189, 244, 0.7);
          transform: scale(1.05);
        }

        .badge-img {
          border-radius: 10px;
          box-shadow: 3px 9px 16px rgba(0, 0, 0, 0.4),
            -3px -3px 10px rgba(0, 26, 37, 0.25);
          transition: all 0.3s ease;
          margin: 10px;
        }

        .badge-img:hover {
          box-shadow: 0 0px 20px rgba(1, 42, 84, 0.7);
          transform: scale(1.05);
        }

        .footer-menu-divider {
          content: "";
          position: absolute;
          right: 0;
          top: 20%;
          transform: translateY(-50%);
          width: 1px;
          height: 13.75px;
          background: #FFF;
        }

        .contact-item {
          color: #99a9b5;
          font-size: 13.75px;
          margin-bottom: 10px;
        }

        .contact-item i {
          margin-right: 10px;
          color: #00bcd4;
        }

        .contact-item a {
          color: #00bcd4;
          text-decoration: none;
        }

        .contact-item a:hover {
          color: white;
        }

        @media (max-width: 768px) {
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
    
      @media screen and (max-width: 900px) {
          .footer-description {
          color: #99a9b5;
          text-align: center;
          font-size: 13.75px;
          line-height: 22px;
          margin: 2vh 0 3vh !important;
          padding: 0 13.75px;
        }
      }
          `}</style>

      <div className="footer-wrapper">
        {/* Diagonal Cross Bottom Left Fade Grid Background */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(45deg, transparent 49%, rgba(255, 255, 255, 0.3) 49%, rgba(255, 255, 255, 0.3) 51%, transparent 51%),
              linear-gradient(-45deg, transparent 49%, rgba(255, 255, 255, 0.3) 49%, rgba(255, 255, 255, 0.3) 51%, transparent 51%)
            `,
            backgroundSize: "40px 40px",
            WebkitMaskImage:
              "radial-gradient(ellipse 100% 100% at 0% 100%, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 40%, transparent 80%)",
            maskImage:
              "radial-gradient(ellipse 100% 100% at 0% 100%, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 40%, transparent 80%)",
            pointerEvents: "none",
            opacity: 0.5,
          }}
        />

        <div className="rain-container" ref={rainContainerRef}>
          {/* Rain drops will be dynamically added here */}
        </div>

        <footer style={{ position: 'relative', zIndex: 2 }}>
          <div className="footer-top">
            <div className="container mx-auto px-4">
              {/* Logo */}
              <div className="flex justify-center mb-6">
                <img
                  src="/assets/assets/images/logo.webp"
                  alt="Paradise-Performance"
                  className="h-16"
                />
              </div>

              {/* Company Description */}
              <p className="footer-description px-24 mx-64 text-white">
                Paradise-Performance is your complete automotive destination in Paradise, TX.
                We're a full-service dealership offering quality pre-owned vehicles including
                cars, golf carts and trailers with competitive financing options.
                We're North Texas's premier European auto repair specialists and expert
                light-duty diesel repair technicians, servicing BMW, Mercedes, Porsche, Audi
                and more with expert technicians and a 1-year/12,000-mile warranty. Whether
                you're buying your next vehicle or maintaining your current one,
                Paradise-Performance has you covered.
              </p>

              {/* Main Content */}
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 text-white">
                {/* Contact Info */}
                <div>
                  <h5 className="footer-title">Visit Us Today</h5>
                  <div className="contact-item">
                    <SafeIcon icon={FaMapMarkerAlt} className="inline mr-2 text-cyan-100" />
                    305 Co Rd 3470<br />Paradise, TX 76073
                  </div>
                  <div className="contact-item">
                    <SafeIcon icon={FaPhone} className="inline mr-2 text-cyan-500" />
                    <a href="tel:8173822316">(817) 382-2316</a>
                  </div>
                  <div className="contact-item" style={{ marginTop: '13.75px', fontSize: '13px' }}>
                    <strong>Sales Hours:</strong><br />
                    Mon-Fri: 9AM-5PM<br />
                    Saturday: 10AM-2PM
                  </div>
                  <div className="contact-item" style={{ marginTop: '10px', fontSize: '13px' }}>
                    <strong>Service Hours:</strong><br />
                    Mon-Fri: 9AM-5PM<br />
                    Sat-Sun: Closed
                  </div>
                </div>

                {/* Focused Dealership Content */}
                <div className="lg:col-span-2 text-white">
                  <div className="grid grid-cols-4 gap-4">
                    {/* Inventory Column */}
                    <div>
                      <h5 className="footer-title">Our Inventory</h5>
                      <Link className="footer-link" to="/vehicles">Automobiles</Link>
                      <Link className="footer-link" to="/golf-carts">Golf Carts</Link>
                      <Link className="footer-link" to="/trailers">Trailers</Link>
                      <Link className="footer-link" to="/parts">Parts & Accessories</Link>
                    </div>

                    {/* Services Column */}
                    <div>
                      <h5 className="footer-title">Dealership Services</h5>
                      <Link className="footer-link" to="/pre-approval">Get Pre-Qualified</Link>
                      <Link className="footer-link" to="/finance-application">Get Financing</Link>
                      <Link className="footer-link" to="/trade-in">Trade-In Value</Link>
                      <Link className="footer-link" to="/warranty">Warranty Info</Link>
                    </div>

                    {/* Areas We Serve */}
                    <div>
                      <h5 className="footer-title">Areas We Serve</h5>
                      <Link className="footer-link" to="/used-cars-decatur-tx">Decatur</Link>
                      <Link className="footer-link" to="/used-cars-wise-county">Wise County</Link>
                      <Link className="footer-link" to="/used-cars-bridgeport-tx">Bridgeport</Link>
                      <Link className="footer-link" to="/used-cars-weatherford-tx">Weatherford</Link>
                      <Link className="footer-link" to="/used-cars-denton-tx">Denton</Link>
                    </div>

                    {/* Resources */}
                    <div>
                      <h5 className="footer-title">Resources</h5>
                      <Link className="footer-link" to="/about">About Us</Link>
                      <Link className="footer-link" to="/contact">Contact</Link>
                      {/* <Link className="footer-link" to="/blog">Blog</Link> */}
                      <a className="footer-link" href="/services" target="_blank" rel="noopener noreferrer">Service Center</a>
                    </div>
                  </div>
                </div>

                {/* Gallery */}
                <div>
                  <h5 className="footer-title">Our Gallery</h5>
                  <div className="gallery-grid">
                    {galleryImages.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Gallery ${index + 1}`}
                        className="gallery-img"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Contact Form and Badges */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8 pb-20">
                <div className="lg:col-span-2">
                  <h5 className="footer-title">Email Us</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <input
                        type="text"
                        placeholder="Your name"
                        className="footer-input"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                      <input
                        type="email"
                        placeholder="Your email"
                        className="footer-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <textarea
                      placeholder="Your message"
                      className="footer-input"
                      style={{ height: '120px', resize: 'vertical' }}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                    <button type="submit" className="footer-submit">
                      Send Message
                    </button>
                  </form>
                </div>

                <div className="text-center">
                  <div className="flex flex-col gap-4 mb-4 items-center">
                    <img
                      src="/assets/assets/images/footer/whoswho-badge.webp"
                      className="inline-block"
                      alt="Who's Who Badge"
                      style={{ maxWidth: '50px', height: '50px' }}
                    />
                    <img
                      src="/assets/assets/images/footer/payments.webp"
                      className="inline-block"
                      alt="Payment Methods Accepted"
                      style={{ maxWidth: '160px', height: 'auto' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 md:grid-cols-3 pt-1 mt-5 mb-5 gap-4 items-center">
                <div className="text-center md:text-left">
                  <div style={{ color: 'oklch(60% .008 40)', fontSize: '9px', lineHeight: '12px' }}>
                    © 2026 Paradise-Performance | All Rights Reserved<br />
                    Designed & Developed <a href="https://websitedesignplano.com" target="_blank" rel="noopener" style={{ color: '#4FC3F7', textDecoration: 'none' }}>WDP</a>
                  </div>
                </div>

                <nav className="text-center">
                  <div className="flex mt-0 pt-0 w-full justify-center space-x-3">
                    <Link to="/about" className="footer-link inline-block">About</Link>
                    <span style={{ color: '#FFF' }}>|</span>
                    <Link to="/contact" className="footer-link inline-block">Contact</Link>
                    <span style={{ color: '#FFF' }}>|</span>
                    <Link to="/warranty" className="footer-link inline-block">Warranty</Link>
                    <span style={{ color: '#FFF' }}>|</span>
                    <Link to="/terms-and-conditions" className="footer-link inline-block">Terms</Link>
                    <span style={{ color: '#FFF' }}>|</span>
                    <Link to="https://paradise-performance.com/blog/" className="footer-link inline-block">Blog</Link>
                  </div>
                </nav>

                <div className="text-center md:text-right">
                  <a rel="nofollow noindex noreferrer noopener" href="https://www.facebook.com/people/Paradise-Performance/100092613115265/"
                    className="social-icon"
                    title="Facebook">
                    <SafeIcon icon={FaFacebookF} style={{ color: '#4e64b5' }} />
                  </a>
                  <a rel="nofollow noindex noreferrer noopener" href="https://www.instagram.com/paradise.performance/" className="social-icon" title="Instagram">
                    <SafeIcon icon={FaInstagram} style={{ color: '#9a8f62' }} />
                  </a>
                  <a rel="nofollow noindex noreferrer noopener" href="https://www.youtube.com/@Paradise-Performance" className="social-icon" title="YouTube">
                    <SafeIcon icon={FaYoutube} style={{ color: '#FFF' }} />
                  </a>

                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default FooterNew;
